import React, { useState } from 'react';
import './LLMPage.scss';
import Navbar from "../../../components/Navbar/Navbar";
import Footer from '../../../components/Footer/Footer';
//
import bot_structure from './langchain_chatbot_structure.jpg';
import scheduling_agent from './scheduling LLM agent.jpg';
import car_manual2 from './car_manual2.png';
// import model2 from './model2.jpg';
// import model3 from './model3.jpg';

const cases = [
    {
        id: 4,
        title: 'Intelligent Manual Assistant for Vehicle Owners',
        info: 'AI-powered system for instant access to vehicle owner\'s manual information',
        details: [
            { type: 'title', text: 'Problem Statement' },
            { type: 'text', text: 'Reading through car manuals is slow, frustrating, and rarely gives you the answer you need—especially when you\'re in a hurry. Our LLM solution helps you find the exact information you\'re looking for in seconds.' },
            { type:'image', src: car_manual2},
            { type: 'text', text: '<div class="image-caption">Sample screenshot from a vehicle owner\'s manual</div>', isHtml: true },
            { type: 'title', text: 'System Overview' },
            { type: 'text', text: 'A domain-tuned LLM system with advanced PDF segmentation, delivering fast, accurate answers from vehicle manuals — no more searching, just ask.' },
            { type: 'title', text: 'Performance Metrics' },
            { type: 'text', text: '<div class="impact-metrics">' +
                '<div class="metric">' +
                '<div class="value">89.6%</div>' +
                '<div class="label">Accuracy on manual queries</div>' +
                '</div>' +
                '<div class="metric">' +
                '<div class="value">+5%</div>' +
                '<div class="label">Over GPT-4 baseline</div>' +
                '</div>' +
                '<div class="metric">' +
                '<div class="value">60%</div>' +
                '<div class="label">Reduction in support queries</div>' +
                '</div>' +
                '<div class="metric">' +
                '<div class="value">75%</div>' +
                '<div class="label">Faster information retrieval</div>' +
                '</div>' +
                '<div class="metric">' +
                '<div class="value">85%</div>' +
                '<div class="label">User satisfaction</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Core Capabilities' },
            { type: 'text', text: '<div class="capabilities">' +
                '<div class="capability">' +
                '<div class="icon">⚡</div>' +
                '<div class="content">' +
                '<div class="title">Instant Responses</div>' +
                '<div class="description">Real-time answers to manual-specific questions</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">👁️</div>' +
                '<div class="content">' +
                '<div class="title">Visual Understanding</div>' +
                '<div class="description">Advanced diagram and symbol recognition</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">🧠</div>' +
                '<div class="content">' +
                '<div class="title">Context Awareness</div>' +
                '<div class="description">Vehicle-specific conversation memory</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">🚗</div>' +
                '<div class="content">' +
                '<div class="title">Multi-Brand Support</div>' +
                '<div class="description">Comprehensive coverage across vehicle models</div>' +
                '</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Powered By' },
            { type: 'text', text: '<div class="tech-stack">' +
                '<div class="tech-item">' +
                '<div class="tech-name">LangChain</div>' +
                '<div class="tech-desc">Intelligent content orchestration</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">Hybrid Retrieval</div>' +
                '<div class="tech-desc">Faiss + BM25 for optimal search</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">vLLM</div>' +
                '<div class="tech-desc">High-performance inference engine</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Business Impact' },
            { type: 'text', text: '<div class="outcome">' +
                '<div class="outcome-item">' +
                '<div class="highlight">Reduced Support Costs</div>' +
                '<div class="detail">Significant decrease in manual support requirements</div>' +
                '</div>' +
                '<div class="outcome-item">' +
                '<div class="highlight">Enhanced Customer Experience</div>' +
                '<div class="detail">Improved satisfaction through instant access</div>' +
                '</div>' +
                '<div class="outcome-item">' +
                '<div class="highlight">Enterprise Scalability</div>' +
                '<div class="detail">Supports 1000+ concurrent users with 99.9% uptime</div>' +
                '</div>' +
                '</div>', isHtml: true }
        ],
    },
    {
        id: 2,
        title: 'Quantizing llama3-8b to W4A16',
        info: 'Optimizing Large Language Models for Efficient Deployment',
        details: [
            { type: 'title', text: 'Problem Statement' },
            { type: 'text', text: 'The llama3-8b model requires significant computational resources and storage, presenting challenges in environments with strict constraints on memory and processing power.' },
            { type: 'title', text: 'System Overview' },
            { type: 'text', text: 'A quantization approach that reduces model size while maintaining performance, enabling efficient deployment in resource-constrained environments.' },
            { type: 'title', text: 'Performance Metrics' },
            { type: 'text', text: '<div class="impact-metrics">' +
                '<div class="metric">' +
                '<div class="value">25.61</div>' +
                '<div class="label">FP16 Accuracy Score</div>' +
                '</div>' +
                '<div class="metric">' +
                '<div class="value">21.95</div>' +
                '<div class="label">W4A16 Accuracy Score</div>' +
                '</div>' +
                '<div class="metric">' +
                '<div class="value">-85%</div>' +
                '<div class="label">Memory Usage</div>' +
                '</div>' +
                '<div class="metric">' +
                '<div class="value">+40%</div>' +
                '<div class="label">Inference Speed</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Cost Savings' },
            { type: 'text', text: '<div class="cost-savings">' +
                '<div class="savings-item">' +
                '<div class="savings-header">GPU Resources</div>' +
                '<div class="savings-detail">' +
                '<div class="detail-row">' +
                '<span class="label">Original:</span>' +
                '<span class="value">8x A100 GPUs</span>' +
                '</div>' +
                '<div class="detail-row">' +
                '<span class="label">Optimized:</span>' +
                '<span class="value">2x A100 GPUs</span>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '<div class="savings-item">' +
                '<div class="savings-header">Annual Savings</div>' +
                '<div class="savings-detail">' +
                '<div class="detail-row">' +
                '<span class="label">GPU Cost:</span>' +
                '<span class="value">$212,371</span>' +
                '</div>' +
                '<div class="detail-row">' +
                '<span class="label">Storage:</span>' +
                '<span class="value">75% reduction</span>' +
                '</div>' +
                '<div class="detail-row">' +
                '<span class="label">Inference:</span>' +
                '<span class="value">75% reduction</span>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Core Capabilities' },
            { type: 'text', text: '<div class="capabilities">' +
                '<div class="capability">' +
                '<div class="icon">⚖️</div>' +
                '<div class="content">' +
                '<div class="title">Weight Quantization</div>' +
                '<div class="description">4-bit precision for optimal storage</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">⚡</div>' +
                '<div class="content">' +
                '<div class="title">Activation Optimization</div>' +
                '<div class="description">16-bit precision for performance</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">🎯</div>' +
                '<div class="content">' +
                '<div class="title">Accuracy Preservation</div>' +
                '<div class="description">Minimal performance impact</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">🚀</div>' +
                '<div class="content">' +
                '<div class="title">Efficient Deployment</div>' +
                '<div class="description">Resource-optimized inference</div>' +
                '</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Technical Architecture' },
            { type: 'text', text: '<div class="tech-stack">' +
                '<div class="tech-item">' +
                '<div class="tech-name">Quantization Framework</div>' +
                '<div class="tech-desc">Custom W4A16 implementation</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">Model Architecture</div>' +
                '<div class="tech-desc">Transformer-based llama3-8b</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">Evaluation Tools</div>' +
                '<div class="tech-desc">Human-eval benchmark suite</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Business Impact' },
            { type: 'text', text: '<div class="outcome">' +
                '<div class="outcome-item">' +
                '<div class="highlight">Resource Optimization</div>' +
                '<div class="detail">Significant reduction in memory and storage requirements</div>' +
                '</div>' +
                '<div class="outcome-item">' +
                '<div class="highlight">Performance Efficiency</div>' +
                '<div class="detail">Faster inference with minimal accuracy trade-off</div>' +
                '</div>' +
                '<div class="outcome-item">' +
                '<div class="highlight">Deployment Flexibility</div>' +
                '<div class="detail">Enabled deployment in resource-constrained environments</div>' +
                '</div>' +
                '</div>', isHtml: true }
        ],
    },
    {
        id: 3,
        title: 'Appointment Scheduling LLM Agent',
        info: 'Intelligent Calendar Management and Scheduling Assistant',
        details: [
            { type:'image', src: scheduling_agent},
            { type: 'title', text: 'System Overview' },
            { type: 'text', text: 'This system aims to streamline the process of client management and appointment scheduling, ' +
                    'reducing the manual effort required by business owners.'},
        ],
    },
    {
        id: 1,
        title: 'Integrating LLM-Backed Agents Across Applications',
        info: 'Your Gateway to Smart Communication and Information Retrieval',
        details: [
            { type:'image', src: bot_structure},
            { type: 'title', text: 'System Overview' },
            { type: 'text', text: 'A comprehensive LLM-powered chatbot system that seamlessly integrates with multiple platforms, providing intelligent information retrieval, email assistance, and real-time internet access capabilities.' },
            { type: 'title', text: 'Core Capabilities' },
            { type: 'text', text: '<div class="capabilities">' +
                '<div class="capability">' +
                '<div class="icon">🔍</div>' +
                '<div class="content">' +
                '<div class="title">Smart Information Retrieval</div>' +
                '<div class="description">RAG-based customized knowledge access</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">🌐</div>' +
                '<div class="content">' +
                '<div class="title">Real-time Internet Access</div>' +
                '<div class="description">Dynamic web information retrieval</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">📧</div>' +
                '<div class="content">' +
                '<div class="title">Email Assistant</div>' +
                '<div class="description">Automated email management</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">🧠</div>' +
                '<div class="content">' +
                '<div class="title">Context Memory</div>' +
                '<div class="description">Personalized conversation history</div>' +
                '</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Technical Architecture' },
            { type: 'text', text: '<div class="tech-stack">' +
                '<div class="tech-item">' +
                '<div class="tech-name">Multi-Platform Integration</div>' +
                '<div class="tech-desc">Telegram, Discord, Slack, Custom Apps</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">API Framework</div>' +
                '<div class="tech-desc">FastAPI for robust communication</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">Orchestration</div>' +
                '<div class="tech-desc">LangChain for query management</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">Infrastructure</div>' +
                '<div class="tech-desc">AWS ECS with Docker containers</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Reliability Features' },
            { type: 'text', text: '<div class="outcome">' +
                '<div class="outcome-item">' +
                '<div class="highlight">Elastic Load Balancing</div>' +
                '<div class="detail">Automatic traffic distribution across instances</div>' +
                '</div>' +
                '<div class="outcome-item">' +
                '<div class="highlight">High Availability</div>' +
                '<div class="detail">Redis Sentinel for failover support</div>' +
                '</div>' +
                '<div class="outcome-item">' +
                '<div class="highlight">Data Resilience</div>' +
                '<div class="detail">Active-passive database configuration</div>' +
                '</div>' +
                '</div>', isHtml: true }
        ],
    },
    {
        id: 5,
        title: 'Intelligent Menu Q&A System',
        info: 'Multi-module system integrating intent recognition, entity extraction, and RAG for menu information retrieval',
        details: [
            { type: 'title', text: 'Problem Statement' },
            { type: 'text', text: 'Traditional menu information systems often lack natural language interaction capabilities and struggle with complex queries about recipes, ingredients, and cooking methods. Our LLM-powered solution enables users to access menu information through natural language queries with high accuracy and rich responses.' },
            { type: 'text', text: '<div class="note-box">' +
                '<div class="note-icon">ℹ️</div>' +
                '<div class="note-content">' +
                '<div class="note-title">Note</div>' +
                '<div class="note-text">For data privacy reasons, this case study uses a menu Q&A system to demonstrate our solution, while maintaining the same technical architecture and performance metrics from our enterprise deployment.</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Why Not Just Use LLM?' },
            { type: 'text', text: '<div class="tech-comparison">' +
                '<div class="comparison-section">' +
                '<div class="comparison-header">🔧 Pain Points of Pure LLM Approach</div>' +
                '<div class="comparison-items">' +
                '<div class="comparison-item">' +
                '<div class="item-title">Unstable Intent Recognition</div>' +
                '<div class="item-desc">LLMs struggle to consistently return structured intent labels needed for system routing</div>' +
                '</div>' +
                '<div class="comparison-item">' +
                '<div class="item-title">Limited Knowledge Retrieval</div>' +
                '<div class="item-desc">Cannot directly retrieve the most relevant item from large menu datasets</div>' +
                '</div>' +
                '<div class="comparison-item">' +
                '<div class="item-title">Hallucination Risk</div>' +
                '<div class="item-desc">Answers may sound plausible but lack factual grounding in recipes</div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '<div class="comparison-section">' +
                '<div class="comparison-header">✅ Our Engineering Response</div>' +
                '<div class="comparison-items">' +
                '<div class="comparison-item">' +
                '<div class="item-title">Fine-tuned Intent Classifier</div>' +
                '<div class="item-desc">Ensures consistent and structured query understanding</div>' +
                '</div>' +
                '<div class="comparison-item">' +
                '<div class="item-title">Vector & Graph Retrieval</div>' +
                '<div class="item-desc">Guarantees fast and accurate access to domain knowledge</div>' +
                '</div>' +
                '<div class="comparison-item">' +
                '<div class="item-title">RAG Architecture</div>' +
                '<div class="item-desc">Fuses retrieved data with generation for reliable answers</div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'System Overview' },
            { type: 'text', text: 'A comprehensive system that combines intent recognition, entity extraction, and RAG to provide accurate and detailed responses to menu-related queries, supporting both Gradio interface and API interactions.' },
            { type: 'title', text: 'Core Capabilities' },
            { type: 'text', text: '<div class="capabilities">' +
                '<div class="capability">' +
                '<div class="icon">🎯</div>' +
                '<div class="content">' +
                '<div class="title">Intent Recognition</div>' +
                '<div class="description">Deep learning model for query intent classification</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">🔍</div>' +
                '<div class="content">' +
                '<div class="title">Entity Extraction</div>' +
                '<div class="description">Aho-Corasick algorithm for dish and ingredient recognition</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">🧠</div>' +
                '<div class="content">' +
                '<div class="title">Knowledge Base</div>' +
                '<div class="description">Neo4j graph database + Milvus vector search</div>' +
                '</div>' +
                '</div>' +
                '<div class="capability">' +
                '<div class="icon">💡</div>' +
                '<div class="content">' +
                '<div class="title">RAG Integration</div>' +
                '<div class="description">Enhanced response generation with retrieval</div>' +
                '</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Technical Architecture' },
            { type: 'text', text: '<div class="tech-stack">' +
                '<div class="tech-item">' +
                '<div class="tech-name">Intent Recognition</div>' +
                '<div class="tech-desc">Fine-tuned large language model for intent classification</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">Entity Recognition</div>' +
                '<div class="tech-desc">Aho-Corasick algorithm with BIO tagging</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">Knowledge Base</div>' +
                '<div class="tech-desc">Neo4j + Milvus with SentenceTransformer</div>' +
                '</div>' +
                '<div class="tech-item">' +
                '<div class="tech-name">Interface</div>' +
                '<div class="tech-desc">Gradio UI + FastAPI service</div>' +
                '</div>' +
                '</div>', isHtml: true },
            { type: 'title', text: 'Business Impact' },
            { type: 'text', text: '<div class="outcome">' +
                '<div class="outcome-item">' +
                '<div class="highlight">Enhanced User Experience</div>' +
                '<div class="detail">Natural language interaction for menu information access</div>' +
                '</div>' +
                '<div class="outcome-item">' +
                '<div class="highlight">Improved Accuracy</div>' +
                '<div class="detail">Combined intent recognition and entity extraction for precise responses</div>' +
                '</div>' +
                '<div class="outcome-item">' +
                '<div class="highlight">Scalable Architecture</div>' +
                '<div class="detail">Modular design supporting easy extension and maintenance</div>' +
                '</div>' +
                '</div>', isHtml: true }
        ],
    },
    // Add more cases as needed.
];



const LLMPage = () => {
    const [activeModal, setActiveModal] = useState(null);

    const openModal = (id) => {
        setActiveModal(id);
    };

    const closeModal = (e) => {
        if (e.target.className === 'case-modal') {
            setActiveModal(null);
        }
    };

    return (
        <div className="rl-page">
            <Navbar />
            <section className="slide-card-header">
                <div className='wrapper'>
                    <div className="outer-frame"></div>
                    <div className="inner-container">
                        <h1>Large Language<br />Model</h1>
                    </div>
                </div>
            </section>

            <section className="rl-content">
                <div className="cases-grid">
                    {cases.map((caseItem, index) => (
                        <div 
                            key={caseItem.id} 
                            className="case-card"
                            onClick={() => openModal(caseItem.id)}
                        >
                            <div className="case-header">
                                <div className="case-number">{index + 1}</div>
                                <h3>{caseItem.title}</h3>
                                <div className="case-info">{caseItem.info}</div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Modal */}
                <div 
                    className={`case-modal ${activeModal ? 'active' : ''}`} 
                    onClick={closeModal}
                >
                    {activeModal && (
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3>{cases.find(c => c.id === activeModal)?.title}</h3>
                                <div className="close-button" onClick={() => setActiveModal(null)}></div>
                            </div>
                            <div className="modal-body">
                                <div className="modal-details">
                                    {cases.find(c => c.id === activeModal)?.details.map((detail, index) => {
                                        if (detail.type === 'image') {
                                            return (
                                                <div key={index} className="image-container">
                                                    <img 
                                                        src={detail.src} 
                                                        alt={`Case detail ${index + 1}`}
                                                    />
                                                </div>
                                            );
                                        } else if (detail.type === 'title') {
                                            return (
                                                <div key={index} className="detail-section">
                                                    <h4>{detail.text}</h4>
                                                </div>
                                            );
                                        } else if (detail.type === 'text') {
                                            return (
                                                <div key={index} className="detail-section">
                                                    {detail.isHtml ? (
                                                        <div dangerouslySetInnerHTML={{ __html: detail.text }} />
                                                    ) : (
                                                        <p>{detail.text}</p>
                                                    )}
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default LLMPage;

